export default {
  namespaced: true,
  state: {
    decoration: {},
    shopState: [
      {
        id: 1081,
        name: "浏览量",
        checked: true,
        type: "documentTotalPv",
      },
      {
        id: 1082,
        name: "下载量",
        checked: true,
        type: "documentTotalDownload",
      },
    ], // 展示的店铺信息
    tabList: [
      {
        alias: "文章",
        menuType: 1,
        content: "",
        sort: 1,
      },
      {
        alias: "视频",
        menuType: 2,
        content: "",
        sort: 2,
      },
      {
        alias: "资料",
        menuType: 3,
        content: "",
        sort: 3,
      },
      {
        alias: "专辑",
        menuType: 4,
        content: "",
        sort: 4,
      },
      {
        alias: "简介",
        menuType: 5,
        content: "",
        sort: 5,
      },
    ], // tab导航楼层列表
    floorList: [], // 主楼层列表
    dialogType: "", // 当前富文本弹窗的类型
    DIYDialogInfo: {}, // 当前自定义内容弹窗的信息
    currentFloor: {}, // 当前选中的楼层信息
    currentContentIndex: 0, // 当前选中的楼层内容的索引（轮播图、快捷导航）
  },
  mutations: {
    setDecoration(state, decoration) {
      state.decoration = decoration;
    },
    setShopState(state, shopState) {
      state.shopState = JSON.parse(JSON.stringify(shopState));
    },
    setTabList(state, tabList) {
      state.tabList = JSON.parse(JSON.stringify(tabList));
    },
    setDialogType(state, dialogType) {
      state.dialogType = JSON.parse(JSON.stringify(dialogType));
    },
    setFloorList(state, floorList) {
      state.floorList = JSON.parse(JSON.stringify(floorList));
    },
    setDIYDialogInfo(state, DIYDialogInfo) {
      state.DIYDialogInfo = JSON.parse(JSON.stringify(DIYDialogInfo));
    },
    setCurrentFloor(state, currentFloor) {
      state.currentFloor = JSON.parse(JSON.stringify(currentFloor));
    },
    setCurrentContentIndex(state, currentContentIndex) {
      state.currentContentIndex = JSON.parse(
        JSON.stringify(currentContentIndex)
      );
    },
  },
};
